webpackJsonp(["common_vue"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ci_icon_vue__ = __webpack_require__("./vue_shared/components/ci_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ci_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ci_icon_vue__);


/**
 * Renders CI Badge link with CI icon and status text based on
 * API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table - first column
 * - Jobs table - first column
 * - Pipeline show view - header
 * - Job show view - header
 * - MR widget
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    status: {
      type: Object,
      required: true
    }
  },

  components: {
    ciIcon: __WEBPACK_IMPORTED_MODULE_0__ci_icon_vue___default.a
  },

  computed: {
    cssClass: function cssClass() {
      var className = this.status.group;

      return className ? 'ci-status ci-' + this.status.group : 'ci-status';
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ci_status_icons__ = __webpack_require__("./vue_shared/ci_status_icons.js");



/**
 * Renders CI icon based on API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table Badge
 * - Pipelines table mini graph
 * - Pipeline graph
 * - Pipeline show view badge
 * - Jobs table
 * - Jobs show view header
 * - Jobs show view sidebar
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    status: {
      type: Object,
      required: true
    }
  },

  computed: {
    statusIconSvg: function statusIconSvg() {
      return __WEBPACK_IMPORTED_MODULE_0__ci_status_icons__["b" /* statusIconEntityMap */][this.status.icon];
    },
    cssClass: function cssClass() {
      var status = this.status.group;
      return 'ci-status-icon ci-status-icon-' + status + ' js-ci-status-icon-' + status;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/commit.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_commit_svg__ = __webpack_require__("../../views/shared/icons/_icon_commit.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_commit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icons_icon_commit_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_avatar_user_avatar_link_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_avatar_user_avatar_link_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__user_avatar_user_avatar_link_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    /**
     * Indicates the existance of a tag.
     * Used to render the correct icon, if true will render `fa-tag` icon,
     * if false will render `fa-code-fork` icon.
     */
    tag: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * If provided is used to render the branch name and url.
     * Should contain the following properties:
     * name
     * ref_url
     */
    commitRef: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    /**
     * Used to link to the commit sha.
     */
    commitUrl: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * Used to show the commit short sha that links to the commit url.
     */
    shortSha: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided shows the commit tile.
     */
    title: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided renders information about the author of the commit.
     * When provided should include:
     * `avatar_url` to render the avatar icon
     * `web_url` to link to user profile
     * `username` to render alt and title tags
     */
    author: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    /**
     * Used to verify if all the properties needed to render the commit
     * ref section were provided.
     *
     * TODO: Improve this! Use lodash _.has when we have it.
     *
     * @returns {Boolean}
     */
    hasCommitRef: function hasCommitRef() {
      return this.commitRef && this.commitRef.name && this.commitRef.ref_url;
    },

    /**
     * Used to verify if all the properties needed to render the commit
     * author section were provided.
     *
     * TODO: Improve this! Use lodash _.has when we have it.
     *
     * @returns {Boolean}
     */
    hasAuthor: function hasAuthor() {
      return this.author && this.author.avatar_url && this.author.path && this.author.username;
    },

    /**
     * If information about the author is provided will return a string
     * to be rendered as the alt attribute of the img tag.
     *
     * @returns {String}
     */
    userImageAltDescription: function userImageAltDescription() {
      return this.author && this.author.username ? this.author.username + '\'s avatar' : null;
    }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_2__directives_tooltip__["a" /* default */]
  },
  components: {
    userAvatarLink: __WEBPACK_IMPORTED_MODULE_1__user_avatar_user_avatar_link_vue___default.a
  },
  created: function created() {
    this.commitIconSvg = __WEBPACK_IMPORTED_MODULE_0_icons_icon_commit_svg___default.a;
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/header_ci_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ci_badge_link_vue__ = __webpack_require__("./vue_shared/components/ci_badge_link.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ci_badge_link_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ci_badge_link_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loading_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_ago_tooltip_vue__ = __webpack_require__("./vue_shared/components/time_ago_tooltip.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_ago_tooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__time_ago_tooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_avatar_user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__user_avatar_user_avatar_image_vue__);







/**
 * Renders header component for job and pipeline page based on UI mockups
 *
 * Used in:
 * - job show page
 * - pipeline show page
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    status: {
      type: Object,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    actions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    hasSidebarButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_3__directives_tooltip__["a" /* default */]
  },

  components: {
    ciIconBadge: __WEBPACK_IMPORTED_MODULE_0__ci_badge_link_vue___default.a,
    loadingIcon: __WEBPACK_IMPORTED_MODULE_1__loading_icon_vue___default.a,
    timeagoTooltip: __WEBPACK_IMPORTED_MODULE_2__time_ago_tooltip_vue___default.a,
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_4__user_avatar_user_avatar_image_vue___default.a
  },

  computed: {
    userAvatarAltText: function userAvatarAltText() {
      return this.user.name + '\'s avatar';
    }
  },

  methods: {
    onClickAction: function onClickAction(action) {
      this.$emit('actionClicked', action);
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/issue/confidential_issue_warning.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confidentialIssueWarning'
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/field.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_vue__ = __webpack_require__("./vue_shared/components/markdown/header.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolbar_vue__ = __webpack_require__("./vue_shared/components/markdown/toolbar.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__toolbar_vue__);

/* global Flash */



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    markdownPreviewPath: {
      type: String,
      required: false,
      default: ''
    },
    markdownDocsPath: {
      type: String,
      required: true
    },
    addSpacingClasses: {
      type: Boolean,
      required: false,
      default: true
    },
    quickActionsDocsPath: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      markdownPreview: '',
      referencedCommands: '',
      referencedUsers: '',
      markdownPreviewLoading: false,
      previewMarkdown: false
    };
  },

  components: {
    markdownHeader: __WEBPACK_IMPORTED_MODULE_0__header_vue___default.a,
    markdownToolbar: __WEBPACK_IMPORTED_MODULE_1__toolbar_vue___default.a
  },
  computed: {
    shouldShowReferencedUsers: function shouldShowReferencedUsers() {
      var referencedUsersThreshold = 10;
      return this.referencedUsers.length >= referencedUsersThreshold;
    }
  },
  methods: {
    toggleMarkdownPreview: function toggleMarkdownPreview() {
      var _this = this;

      this.previewMarkdown = !this.previewMarkdown;

      /*
        Can't use `$refs` as the component is technically in the parent component
        so we access the VNode & then get the element
      */
      var text = this.$slots.textarea[0].elm.value;

      if (!this.previewMarkdown) {
        this.markdownPreview = '';
      } else if (text) {
        this.markdownPreviewLoading = true;
        this.$http.post(this.markdownPreviewPath, { text: text }).then(function (resp) {
          return resp.json();
        }).then(function (data) {
          _this.renderMarkdown(data);
        }).catch(function () {
          return new Flash('Error loading markdown preview');
        });
      } else {
        this.renderMarkdown();
      }
    },
    renderMarkdown: function renderMarkdown() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.markdownPreviewLoading = false;
      this.markdownPreview = data.body || 'Nothing to preview.';

      if (data.references) {
        this.referencedCommands = data.references.commands;
        this.referencedUsers = data.references.users;
      }

      this.$nextTick(function () {
        $(_this2.$refs['markdown-preview']).renderGFM();
      });
    }
  },
  mounted: function mounted() {
    /*
      GLForm class handles all the toolbar buttons
    */
    return new gl.GLForm($(this.$refs['gl-form']), true);
  },
  beforeDestroy: function beforeDestroy() {
    var glForm = $(this.$refs['gl-form']).data('gl-form');
    if (glForm) {
      glForm.destroy();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/header.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolbar_button_vue__ = __webpack_require__("./vue_shared/components/markdown/toolbar_button.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolbar_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__toolbar_button_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    previewMarkdown: {
      type: Boolean,
      required: true
    }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__["a" /* default */]
  },
  components: {
    toolbarButton: __WEBPACK_IMPORTED_MODULE_1__toolbar_button_vue___default.a
  },
  methods: {
    toggleMarkdownPreview: function toggleMarkdownPreview(e, form) {
      if (form && !form.find('.js-vue-markdown-field').length) {
        return;
      } else if (e.target.blur) {
        e.target.blur();
      }

      this.$emit('toggle-markdown');
    }
  },
  mounted: function mounted() {
    $(document).on('markdown-preview:show.vue', this.toggleMarkdownPreview);
    $(document).on('markdown-preview:hide.vue', this.toggleMarkdownPreview);
  },
  beforeDestroy: function beforeDestroy() {
    $(document).on('markdown-preview:show.vue', this.toggleMarkdownPreview);
    $(document).off('markdown-preview:hide.vue', this.toggleMarkdownPreview);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/toolbar.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    markdownDocsPath: {
      type: String,
      required: true
    },
    quickActionsDocsPath: {
      type: String,
      required: false
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/toolbar_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    buttonTitle: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      required: true
    },
    tagBlock: {
      type: String,
      required: false,
      default: ''
    },
    prepend: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__["a" /* default */]
  },
  computed: {
    iconClass: function iconClass() {
      return 'fa-' + this.icon;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/popup_dialog.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup-dialog',

  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    kind: {
      type: String,
      required: false,
      default: 'primary'
    },
    closeButtonLabel: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    primaryButtonLabel: {
      type: String,
      required: true
    }
  },

  computed: {
    btnKindClass: function btnKindClass() {
      return _defineProperty({}, 'btn-' + this.kind, true);
    }
  },

  methods: {
    close: function close() {
      this.$emit('toggle', false);
    },
    emitSubmit: function emitSubmit(status) {
      this.$emit('submit', status);
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/table_pagination.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var PAGINATION_UI_BUTTON_LIMIT = 4;
var UI_LIMIT = 6;
var SPREAD = '...';
var PREV = 'Prev';
var NEXT = 'Next';
var FIRST = '« First';
var LAST = 'Last »';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    /**
      This function will take the information given by the pagination component
       Here is an example `change` method:
       change(pagenum) {
        gl.utils.visitUrl(`?page=${pagenum}`);
      },
    */
    change: {
      type: Function,
      required: true
    },

    /**
      pageInfo will come from the headers of the API call
      in the `.then` clause of the VueResource API call
      there should be a function that contructs the pageInfo for this component
       This is an example:
       const pageInfo = headers => ({
        perPage: +headers['X-Per-Page'],
        page: +headers['X-Page'],
        total: +headers['X-Total'],
        totalPages: +headers['X-Total-Pages'],
        nextPage: +headers['X-Next-Page'],
        previousPage: +headers['X-Prev-Page'],
      });
    */
    pageInfo: {
      type: Object,
      required: true
    }
  },
  methods: {
    changePage: function changePage(e) {
      if (e.target.parentElement.classList.contains('disabled')) return;

      var text = e.target.innerText;
      var _pageInfo = this.pageInfo,
          totalPages = _pageInfo.totalPages,
          nextPage = _pageInfo.nextPage,
          previousPage = _pageInfo.previousPage;


      switch (text) {
        case SPREAD:
          break;
        case LAST:
          this.change(totalPages);
          break;
        case NEXT:
          this.change(nextPage);
          break;
        case PREV:
          this.change(previousPage);
          break;
        case FIRST:
          this.change(1);
          break;
        default:
          this.change(+text);
          break;
      }
    }
  },
  computed: {
    prev: function prev() {
      return this.pageInfo.previousPage;
    },
    next: function next() {
      return this.pageInfo.nextPage;
    },
    getItems: function getItems() {
      var total = this.pageInfo.totalPages;
      var page = this.pageInfo.page;
      var items = [];

      if (page > 1) {
        items.push({ title: FIRST, first: true });
      }

      if (page > 1) {
        items.push({ title: PREV, prev: true });
      } else {
        items.push({ title: PREV, disabled: true, prev: true });
      }

      if (page > UI_LIMIT) items.push({ title: SPREAD, separator: true });

      var start = Math.max(page - PAGINATION_UI_BUTTON_LIMIT, 1);
      var end = Math.min(page + PAGINATION_UI_BUTTON_LIMIT, total);

      for (var i = start; i <= end; i += 1) {
        var isActive = i === page;
        items.push({ title: i, active: isActive, page: true });
      }

      if (total - page > PAGINATION_UI_BUTTON_LIMIT) {
        items.push({ title: SPREAD, separator: true, page: true });
      }

      if (page === total) {
        items.push({ title: NEXT, disabled: true, next: true });
      } else if (total - page >= 1) {
        items.push({ title: NEXT, next: true });
      }

      if (total - page >= 1) {
        items.push({ title: LAST, last: true });
      }

      return items;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/time_ago_tooltip.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_timeago__ = __webpack_require__("./vue_shared/mixins/timeago.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");





/**
 * Port of ruby helper time_ago_with_tooltip
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    time: {
      type: String,
      required: true
    },

    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },

    cssClass: {
      type: String,
      required: false,
      default: ''
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_timeago__["a" /* default */]],

  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__["a" /* default */]
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_images_no_avatar_png__ = __webpack_require__("../images/no_avatar.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_images_no_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_images_no_avatar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserAvatarImage',
  props: {
    imgSrc: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_0_images_no_avatar_png___default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_1__directives_tooltip__["a" /* default */]
  },
  computed: {
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    },

    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    imageSource: function imageSource() {
      return this.imgSrc === '' || this.imgSrc === null ? __WEBPACK_IMPORTED_MODULE_0_images_no_avatar_png___default.a : this.imgSrc;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__user_avatar_image_vue__);


/* This is a re-usable vue component for rendering a user avatar wrapped in
  a clickable link (likely to the user's profile). The link, image, and
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-link
    :link-href="userProfileUrl"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :img-size="20"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserAvatarLink',
  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_0__user_avatar_image_vue___default.a
  },
  props: {
    linkHref: {
      type: String,
      required: false,
      default: ''
    },
    imgSrc: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: ''
    },
    imgCssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgSize: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  }
});

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-22bc8c00\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.cssClass,
    attrs: {
      "href": _vm.status.details_path
    }
  }, [_c('ci-icon', {
    attrs: {
      "status": _vm.status
    }
  }), _vm._v("\n  " + _vm._s(_vm.status.text) + "\n")], 1)
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-25770372\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar_button.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "toolbar-btn js-md hidden-xs",
    attrs: {
      "type": "button",
      "tabindex": "-1",
      "data-container": "body",
      "data-md-tag": _vm.tag,
      "data-md-block": _vm.tagBlock,
      "data-md-prepend": _vm.prepend,
      "title": _vm.buttonTitle,
      "aria-label": _vm.buttonTitle
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: _vm.iconClass,
    attrs: {
      "aria-hidden": "true"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-319f0f0c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-toolbar clearfix"
  }, [_c('div', {
    staticClass: "toolbar-text"
  }, [(!_vm.quickActionsDocsPath && _vm.markdownDocsPath) ? [_c('a', {
    attrs: {
      "href": _vm.markdownDocsPath,
      "target": "_blank",
      "tabindex": "-1"
    }
  }, [_vm._v("\n        Markdown is supported\n      ")])] : _vm._e(), _vm._v(" "), (_vm.quickActionsDocsPath && _vm.markdownDocsPath) ? [_c('a', {
    attrs: {
      "href": _vm.markdownDocsPath,
      "target": "_blank",
      "tabindex": "-1"
    }
  }, [_vm._v("\n        Markdown\n      ")]), _vm._v("\n      and\n       "), _c('a', {
    attrs: {
      "href": _vm.quickActionsDocsPath,
      "target": "_blank",
      "tabindex": "-1"
    }
  }, [_vm._v("\n        quick actions\n      ")]), _vm._v("\n      are supported\n    ")] : _vm._e()], 2), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "uploading-container"
  }, [_c('span', {
    staticClass: "uploading-progress-container hide"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "attaching-file-message"
  }), _vm._v(" "), _c('span', {
    staticClass: "uploading-progress"
  }, [_vm._v("0%")]), _vm._v(" "), _c('span', {
    staticClass: "uploading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "uploading-error-container hide"
  }, [_c('span', {
    staticClass: "uploading-error-icon"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "uploading-error-message"
  }), _vm._v(" "), _c('button', {
    staticClass: "retry-uploading-link",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n          Try again\n      ")]), _vm._v("\n      or\n      "), _c('button', {
    staticClass: "attach-new-file markdown-selector",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n        attach a new file\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "markdown-selector button-attach-file",
    attrs: {
      "tabindex": "-1",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Attach a file\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs hide button-cancel-uploading-files",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n      Cancel\n    ")])])
}]}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-3b42ba16\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/commit.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "branch-commit"
  }, [(_vm.hasCommitRef) ? _c('div', {
    staticClass: "icon-container hidden-xs"
  }, [(_vm.tag) ? _c('i', {
    staticClass: "fa fa-tag",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.tag) ? _c('i', {
    staticClass: "fa fa-code-fork",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasCommitRef) ? _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "ref-name hidden-xs",
    attrs: {
      "href": _vm.commitRef.ref_url,
      "data-container": "body",
      "title": _vm.commitRef.name
    }
  }, [_vm._v("\n    " + _vm._s(_vm.commitRef.name) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "commit-icon js-commit-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.commitIconSvg)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "commit-sha",
    attrs: {
      "href": _vm.commitUrl
    }
  }, [_vm._v("\n    " + _vm._s(_vm.shortSha) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "commit-title flex-truncate-parent"
  }, [(_vm.title) ? _c('span', {
    staticClass: "flex-truncate-child"
  }, [(_vm.hasAuthor) ? _c('user-avatar-link', {
    staticClass: "avatar-image-container",
    attrs: {
      "link-href": _vm.author.path,
      "img-src": _vm.author.avatar_url,
      "img-alt": _vm.userImageAltDescription,
      "tooltip-text": _vm.author.username
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "commit-row-message",
    attrs: {
      "href": _vm.commitUrl
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])], 1) : _c('span', [_vm._v("\n      Cant find HEAD commit for this branch\n    ")])])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-404deeca\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/table_pagination.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gl-pagination"
  }, [_c('ul', {
    staticClass: "pagination clearfix"
  }, _vm._l((_vm.getItems), function(item) {
    return _c('li', {
      class: {
        page: item.page,
          'js-previous-button': item.prev,
          'js-next-button': item.next,
          'js-last-button': item.last,
          'js-first-button': item.first,
          separator: item.separator,
          active: item.active,
          disabled: item.disabled
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePage($event)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-5b8765d4\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/issue/confidential_issue_warning.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confidential-issue-warning"
  }, [_c('i', {
    staticClass: "fa fa-eye-slash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n    This is a confidential issue. Your comment will not be visible to the public.\n  ")])])
}]}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7590a963\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.cssClass,
    domProps: {
      "innerHTML": _vm._s(_vm.statusIconSvg)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7a799207\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/header_ci_component.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-content-header ci-header-container"
  }, [_c('section', {
    staticClass: "header-main-content"
  }, [_c('ci-icon-badge', {
    attrs: {
      "status": _vm.status
    }
  }), _vm._v(" "), _c('strong', [_vm._v("\n      " + _vm._s(_vm.itemName) + " #" + _vm._s(_vm.itemId) + "\n    ")]), _vm._v("\n\n    triggered\n\n    "), _c('timeago-tooltip', {
    attrs: {
      "time": _vm.time
    }
  }), _vm._v("\n\n    by\n\n    "), (_vm.user) ? [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "js-user-link commit-committer-link",
    attrs: {
      "href": _vm.user.path,
      "title": _vm.user.email
    }
  }, [_c('user-avatar-image', {
    attrs: {
      "img-src": _vm.user.avatar_url,
      "img-alt": _vm.userAvatarAltText,
      "tooltip-text": _vm.user.name,
      "img-size": 24
    }
  }), _vm._v("\n\n        " + _vm._s(_vm.user.name) + "\n      ")], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.actions.length) ? _c('section', {
    staticClass: "header-action-buttons"
  }, [_vm._l((_vm.actions), function(action) {
    return [(action.type === 'link') ? _c('a', {
      class: action.cssClass,
      attrs: {
        "href": action.path
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")]) : (action.type === 'ujs-link') ? _c('a', {
      class: action.cssClass,
      attrs: {
        "href": action.path,
        "data-method": "post",
        "rel": "nofollow"
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")]) : (action.type === 'button') ? _c('button', {
      class: action.cssClass,
      attrs: {
        "disabled": action.isLoading,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onClickAction(action)
        }
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n        "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isLoading),
        expression: "action.isLoading"
      }],
      staticClass: "fa fa-spin fa-spinner",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]
  }), _vm._v(" "), (_vm.hasSidebarButton) ? _c('button', {
    staticClass: "btn btn-default visible-xs-block visible-sm-block sidebar-toggle-btn js-sidebar-build-toggle js-sidebar-build-toggle-header",
    attrs: {
      "type": "button",
      "aria-label": "Toggle Sidebar",
      "id": "toggleSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true",
      "aria-labelledby": "toggleSidebar"
    }
  })]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7d90f78e\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/field.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gl-form",
    staticClass: "md-area js-vue-markdown-field",
    class: {
      'prepend-top-default append-bottom-default': _vm.addSpacingClasses
    }
  }, [_c('markdown-header', {
    attrs: {
      "preview-markdown": _vm.previewMarkdown
    },
    on: {
      "toggle-markdown": _vm.toggleMarkdownPreview
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.previewMarkdown),
      expression: "!previewMarkdown"
    }],
    staticClass: "md-write-holder"
  }, [_c('div', {
    staticClass: "zen-backdrop"
  }, [_vm._t("textarea"), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('markdown-toolbar', {
    attrs: {
      "markdown-docs-path": _vm.markdownDocsPath,
      "quick-actions-docs-path": _vm.quickActionsDocsPath
    }
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewMarkdown),
      expression: "previewMarkdown"
    }],
    staticClass: "md md-preview-holder md-preview"
  }, [_c('div', {
    ref: "markdown-preview",
    domProps: {
      "innerHTML": _vm._s(_vm.markdownPreview)
    }
  }), _vm._v(" "), (_vm.markdownPreviewLoading) ? _c('span', [_vm._v("\n      Loading...\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.previewMarkdown && !_vm.markdownPreviewLoading) ? [(_vm.referencedCommands) ? _c('div', {
    staticClass: "referenced-commands",
    domProps: {
      "innerHTML": _vm._s(_vm.referencedCommands)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldShowReferencedUsers) ? _c('div', {
    staticClass: "referenced-users"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          You are about to add\n          "), _c('strong', [_c('span', {
    staticClass: "js-referenced-users-count"
  }, [_vm._v("\n              " + _vm._s(_vm.referencedUsers.length) + "\n            ")])]), _vm._v(" people to the discussion. Proceed with caution.\n        ")])]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "zen-control zen-control-leave js-zen-leave",
    attrs: {
      "href": "#",
      "aria-label": "Enter zen mode"
    }
  }, [_c('i', {
    staticClass: "fa fa-compress",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7e4a01d0\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "avatar",
    class: [_vm.avatarSizeClass, _vm.cssClasses],
    attrs: {
      "src": _vm.imageSource,
      "width": _vm.size,
      "height": _vm.size,
      "alt": _vm.imgAlt,
      "data-container": _vm.tooltipContainer,
      "data-placement": _vm.tooltipPlacement,
      "title": _vm.tooltipText
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-88540444\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/header.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-header"
  }, [_c('ul', {
    staticClass: "nav-links clearfix"
  }, [_c('li', {
    class: {
      active: !_vm.previewMarkdown
    }
  }, [_c('a', {
    attrs: {
      "href": "#md-write-holder",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleMarkdownPreview($event)
      }
    }
  }, [_vm._v("\n        Write\n      ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.previewMarkdown
    }
  }, [_c('a', {
    attrs: {
      "href": "#md-preview-holder",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleMarkdownPreview($event)
      }
    }
  }, [_vm._v("\n        Preview\n      ")])]), _vm._v(" "), _c('li', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "toolbar-group"
  }, [_c('toolbar-button', {
    attrs: {
      "tag": "**",
      "button-title": "Add bold text",
      "icon": "bold"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "*",
      "button-title": "Add italic text",
      "icon": "italic"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "> ",
      "prepend": true,
      "button-title": "Insert a quote",
      "icon": "quote-right"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "`",
      "tag-block": "```",
      "button-title": "Insert code",
      "icon": "code"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "* ",
      "prepend": true,
      "button-title": "Add a bullet list",
      "icon": "list-ul"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "1. ",
      "prepend": true,
      "button-title": "Add a numbered list",
      "icon": "list-ol"
    }
  }), _vm._v(" "), _c('toolbar-button', {
    attrs: {
      "tag": "* [ ] ",
      "prepend": true,
      "button-title": "Add a task list",
      "icon": "check-square-o"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar-group"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "toolbar-btn js-zen-enter",
    attrs: {
      "aria-label": "Go full screen",
      "data-container": "body",
      "tabindex": "-1",
      "title": "Go full screen",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-8ca1244c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/popup_dialog.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal popup-dialog",
    attrs: {
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(this.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(this.body))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emitSubmit(false)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.closeButtonLabel) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: _vm.btnKindClass,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emitSubmit(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.primaryButtonLabel) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-b61a630c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('time', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    class: _vm.cssClass,
    attrs: {
      "title": _vm.tooltipTitle(_vm.time),
      "data-placement": _vm.tooltipPlacement,
      "data-container": "body"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.timeFormated(_vm.time)) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-bcca3766\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "user-avatar-link",
    attrs: {
      "href": _vm.linkHref
    }
  }, [_c('user-avatar-image', {
    attrs: {
      "img-src": _vm.imgSrc,
      "img-alt": _vm.imgAlt,
      "css-classes": _vm.imgCssClasses,
      "size": _vm.imgSize,
      "tooltip-text": _vm.tooltipText,
      "tooltip-placement": _vm.tooltipPlacement
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "./vue_shared/ci_action_icons.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getActionIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_action_cancel_svg__ = __webpack_require__("../../views/shared/icons/_icon_action_cancel.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_action_cancel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icons_icon_action_cancel_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_action_retry_svg__ = __webpack_require__("../../views/shared/icons/_icon_action_retry.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_action_retry_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icons_icon_action_retry_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_icons_icon_action_play_svg__ = __webpack_require__("../../views/shared/icons/_icon_action_play.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_icons_icon_action_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_icons_icon_action_play_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icons_icon_action_stop_svg__ = __webpack_require__("../../views/shared/icons/_icon_action_stop.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icons_icon_action_stop_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icons_icon_action_stop_svg__);





/**
 * For the provided action returns the respective SVG
 *
 * @param  {String} action
 * @return {SVG|String}
 */
function getActionIcon(action) {
  var icons = {
    icon_action_cancel: __WEBPACK_IMPORTED_MODULE_0_icons_icon_action_cancel_svg___default.a,
    icon_action_play: __WEBPACK_IMPORTED_MODULE_2_icons_icon_action_play_svg___default.a,
    icon_action_retry: __WEBPACK_IMPORTED_MODULE_1_icons_icon_action_retry_svg___default.a,
    icon_action_stop: __WEBPACK_IMPORTED_MODULE_3_icons_icon_action_stop_svg___default.a
  };

  return icons[action] || '';
}

/***/ }),

/***/ "./vue_shared/ci_status_icons.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderlessStatusIconEntityMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return statusIconEntityMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_status_canceled_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_canceled_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_status_canceled_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icons_icon_status_canceled_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_status_created_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_created_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_status_created_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icons_icon_status_created_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_icons_icon_status_failed_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_failed_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_icons_icon_status_failed_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_icons_icon_status_failed_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icons_icon_status_manual_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_manual_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icons_icon_status_manual_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icons_icon_status_manual_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_icons_icon_status_pending_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_pending_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_icons_icon_status_pending_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_icons_icon_status_pending_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icons_icon_status_running_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_running_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icons_icon_status_running_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_icons_icon_status_running_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_icons_icon_status_skipped_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_skipped_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_icons_icon_status_skipped_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_icons_icon_status_skipped_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_icons_icon_status_success_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_success_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_icons_icon_status_success_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_icons_icon_status_success_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_icons_icon_status_warning_borderless_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_warning_borderless.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_icons_icon_status_warning_borderless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_icons_icon_status_warning_borderless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_icons_icon_status_canceled_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_canceled.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_icons_icon_status_canceled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_icons_icon_status_canceled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_icons_icon_status_created_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_created.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_icons_icon_status_created_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_icons_icon_status_created_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_icons_icon_status_failed_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_failed.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_icons_icon_status_failed_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_icons_icon_status_failed_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_icons_icon_status_manual_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_manual.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_icons_icon_status_manual_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_icons_icon_status_manual_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_icons_icon_status_pending_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_pending.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_icons_icon_status_pending_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_icons_icon_status_pending_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_icons_icon_status_running_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_running.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_icons_icon_status_running_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_icons_icon_status_running_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_icons_icon_status_skipped_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_skipped.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_icons_icon_status_skipped_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_icons_icon_status_skipped_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_icons_icon_status_success_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_success.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_icons_icon_status_success_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_icons_icon_status_success_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_icons_icon_status_warning_svg__ = __webpack_require__("../../views/shared/icons/_icon_status_warning.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_icons_icon_status_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_icons_icon_status_warning_svg__);




















var borderlessStatusIconEntityMap = {
  icon_status_canceled: __WEBPACK_IMPORTED_MODULE_0_icons_icon_status_canceled_borderless_svg___default.a,
  icon_status_created: __WEBPACK_IMPORTED_MODULE_1_icons_icon_status_created_borderless_svg___default.a,
  icon_status_failed: __WEBPACK_IMPORTED_MODULE_2_icons_icon_status_failed_borderless_svg___default.a,
  icon_status_manual: __WEBPACK_IMPORTED_MODULE_3_icons_icon_status_manual_borderless_svg___default.a,
  icon_status_pending: __WEBPACK_IMPORTED_MODULE_4_icons_icon_status_pending_borderless_svg___default.a,
  icon_status_running: __WEBPACK_IMPORTED_MODULE_5_icons_icon_status_running_borderless_svg___default.a,
  icon_status_skipped: __WEBPACK_IMPORTED_MODULE_6_icons_icon_status_skipped_borderless_svg___default.a,
  icon_status_success: __WEBPACK_IMPORTED_MODULE_7_icons_icon_status_success_borderless_svg___default.a,
  icon_status_warning: __WEBPACK_IMPORTED_MODULE_8_icons_icon_status_warning_borderless_svg___default.a
};

var statusIconEntityMap = {
  icon_status_canceled: __WEBPACK_IMPORTED_MODULE_9_icons_icon_status_canceled_svg___default.a,
  icon_status_created: __WEBPACK_IMPORTED_MODULE_10_icons_icon_status_created_svg___default.a,
  icon_status_failed: __WEBPACK_IMPORTED_MODULE_11_icons_icon_status_failed_svg___default.a,
  icon_status_manual: __WEBPACK_IMPORTED_MODULE_12_icons_icon_status_manual_svg___default.a,
  icon_status_pending: __WEBPACK_IMPORTED_MODULE_13_icons_icon_status_pending_svg___default.a,
  icon_status_running: __WEBPACK_IMPORTED_MODULE_14_icons_icon_status_running_svg___default.a,
  icon_status_skipped: __WEBPACK_IMPORTED_MODULE_15_icons_icon_status_skipped_svg___default.a,
  icon_status_success: __WEBPACK_IMPORTED_MODULE_16_icons_icon_status_success_svg___default.a,
  icon_status_warning: __WEBPACK_IMPORTED_MODULE_17_icons_icon_status_warning_svg___default.a
};

/***/ }),

/***/ "./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_badge_link.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-22bc8c00\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/ci_icon.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7590a963\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/commit.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/commit.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-3b42ba16\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/commit.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/header_ci_component.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/header_ci_component.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7a799207\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/header_ci_component.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/issue/confidential_issue_warning.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/issue/confidential_issue_warning.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-5b8765d4\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/issue/confidential_issue_warning.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/markdown/field.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/field.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7d90f78e\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/field.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/markdown/header.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/header.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-88540444\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/header.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/markdown/toolbar.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/toolbar.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-319f0f0c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/markdown/toolbar_button.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/toolbar_button.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-25770372\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar_button.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/memory_graph.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemoryGraph',
  props: {
    metrics: { type: Array, required: true },
    deploymentTime: { type: Number, required: true },
    width: { type: String, required: true },
    height: { type: String, required: true }
  },
  data: function data() {
    return {
      pathD: '',
      pathViewBox: '',
      dotX: '',
      dotY: ''
    };
  },

  computed: {
    getFormattedMedian: function getFormattedMedian() {
      var deployedSince = gl.utils.getTimeago().format(this.deploymentTime * 1000);
      return 'Deployed ' + deployedSince;
    }
  },
  methods: {
    /**
     * Returns metric value index in metrics array
     * with timestamp closest to matching median
     */
    getMedianMetricIndex: function getMedianMetricIndex(median, metrics) {
      var matchIndex = 0;
      var timestampDiff = 0;
      var smallestDiff = 0;

      var metricTimestamps = metrics.map(function (v) {
        return v[0];
      });

      // Find metric timestamp which is closest to deploymentTime
      timestampDiff = Math.abs(metricTimestamps[0] - median);
      metricTimestamps.forEach(function (timestamp, index) {
        if (index === 0) {
          // Skip first element
          return;
        }

        smallestDiff = Math.abs(timestamp - median);
        if (smallestDiff < timestampDiff) {
          matchIndex = index;
          timestampDiff = smallestDiff;
        }
      });

      return matchIndex;
    },


    /**
     * Get Graph Plotting values to render Line and Dot
     */
    getGraphPlotValues: function getGraphPlotValues(median, metrics) {
      var renderData = metrics.map(function (v) {
        return v[1];
      });
      var medianMetricIndex = this.getMedianMetricIndex(median, metrics);
      var cx = 0;
      var cy = 0;

      // Find Maximum and Minimum values from `renderData` array
      var maxMemory = Math.max.apply(null, renderData);
      var minMemory = Math.min.apply(null, renderData);

      // Find difference between extreme ends
      var diff = maxMemory - minMemory;
      var lineWidth = renderData.length;

      // Iterate over metrics values and perform following
      // 1. Find x & y co-ords for deploymentTime's memory value
      // 2. Return line path against maxMemory
      var linePath = renderData.map(function (y, x) {
        if (medianMetricIndex === x) {
          cx = x;
          cy = maxMemory - y;
        }
        return x + ' ' + (maxMemory - y);
      });

      return {
        pathD: linePath,
        pathViewBox: {
          lineWidth: lineWidth,
          diff: diff
        },
        dotX: cx,
        dotY: cy
      };
    },


    /**
     * Render Graph based on provided median and metrics values
     */
    renderGraph: function renderGraph(median, metrics) {
      var _getGraphPlotValues = this.getGraphPlotValues(median, metrics),
          pathD = _getGraphPlotValues.pathD,
          pathViewBox = _getGraphPlotValues.pathViewBox,
          dotX = _getGraphPlotValues.dotX,
          dotY = _getGraphPlotValues.dotY;

      // Set props and update graph on UI.


      this.pathD = 'M ' + pathD;
      this.pathViewBox = '0 0 ' + pathViewBox.lineWidth + ' ' + pathViewBox.diff;
      this.dotX = dotX;
      this.dotY = dotY;
    }
  },
  mounted: function mounted() {
    this.renderGraph(this.deploymentTime, this.metrics);
  },

  template: '\n    <div class="memory-graph-container">\n      <svg class="has-tooltip" :title="getFormattedMedian" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">\n        <path :d="pathD" :viewBox="pathViewBox" />\n        <circle r="1.5" :cx="dotX" :cy="dotY" tranform="translate(0 -1)" />\n      </svg>\n    </div>\n  '
});

/***/ }),

/***/ "./vue_shared/components/popup_dialog.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/popup_dialog.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-8ca1244c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/popup_dialog.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/table_pagination.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/table_pagination.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-404deeca\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/table_pagination.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/time_ago_tooltip.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/time_ago_tooltip.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-b61a630c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7e4a01d0\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_link.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-bcca3766\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/directives/popover.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Helper to user bootstrap popover in vue.js.
 * Follow docs for html attributes: https://getbootstrap.com/docs/3.3/javascript/#static-popover
 *
 * @example
 * import popover from 'vue_shared/directives/popover.js';
 * {
 *   directives: [popover]
 * }
 * <a v-popover="{options}">popover</a>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    $(el).popover(binding.value);
  },
  unbind: function unbind(el) {
    $(el).popover('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/mixins/timeago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");


/**
 * Mixin with time ago methods used in some vue components
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    timeFormated: function timeFormated(time) {
      var timeago = gl.utils.getTimeago();

      return timeago.format(time);
    },
    tooltipTitle: function tooltipTitle(time) {
      return gl.utils.formatDate(time);
    }
  }
});

/***/ }),

/***/ "./vue_shared/vue_resource_interceptor.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.es2015.js");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// Maintain a global counter for active requests
// see: spec/support/wait_for_requests.rb
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  window.activeVueResources = window.activeVueResources || 0;
  window.activeVueResources += 1;

  next(function () {
    window.activeVueResources -= 1;
  });
});

// Inject CSRF token and parse headers.
// New Vue Resource version uses Headers, we are expecting a plain object to render pagination
// and polling.
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  if ($.rails) {
    request.headers.set('X-CSRF-Token', $.rails.csrfToken());
  }

  next(function (response) {
    // Headers object has a `forEach` property that iterates through all values.
    var headers = {};

    response.headers.forEach(function (value, key) {
      headers[key] = value;
    });
    // eslint-disable-next-line no-param-reassign
    response.headers = headers;
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./vue_shared/vue_resource_interceptor.js"]);


// WEBPACK FOOTER //
// common_vue.beab3ef505e8270b8761.bundle.js